import { useMemo } from "react";

import { typedQueryClient } from "hooks";
import { ParkingGateCodesDashboardQueryKeys } from "modules/ParkingGateCodesDashboard/queryKeys";

import type { WebSocketMessageListener } from "components";
import type { ParkingGateCode } from "models";

export const useParkingGateCodesListeners = () =>
  useMemo(() => {
    const parkingGateCodesListeners: WebSocketMessageListener<ParkingGateCode>[] = [
      {
        model: "ParkingGateCode",
        action: "upsert",
        callback: ({ data: parkingGateCode }) => {
          const parkingGateCodes = typedQueryClient.getQueryData(ParkingGateCodesDashboardQueryKeys.parkingGateCodes);

          const parkingGateCodeIdx = parkingGateCodes?.findIndex(pgc => pgc.id === parkingGateCode.id) ?? -1;
          const updatedParkingGateCodes = [...(parkingGateCodes || [])];

          typedQueryClient.setQueryData(
            ParkingGateCodesDashboardQueryKeys.parkingGateCodes,
            parkingGateCodeIdx === -1
              ? [...updatedParkingGateCodes, parkingGateCode]
              : updatedParkingGateCodes.with(parkingGateCodeIdx, { ...updatedParkingGateCodes[parkingGateCodeIdx], ...parkingGateCode })
          );
        }
      },
      {
        model: "ParkingGateCode",
        action: "delete",
        callback: ({ data: parkingGateCode }) => {
          const parkingGateCodes = typedQueryClient.getQueryData(ParkingGateCodesDashboardQueryKeys.parkingGateCodes);
          if (!parkingGateCodes || !parkingGateCodes.length) return;

          const parkingGateCodeIdx = parkingGateCodes.findIndex(pgc => pgc.id === parkingGateCode.id);
          if (parkingGateCodeIdx === -1) return;

          typedQueryClient.setQueryData(ParkingGateCodesDashboardQueryKeys.parkingGateCodes, parkingGateCodes.toSpliced(parkingGateCodeIdx, 1));
        }
      }
    ];

    return parkingGateCodesListeners;
  }, []);
